import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { escapeLabel, formatLabel, ScaleType } from '@swimlane/ngx-charts';

import { Color, colorSets } from '@swimlane/ngx-charts';
import { ProfilerLofiQueryResult } from 'src/app/profiler/model/profiler-lofi-report';
@Component({
  selector: 'atlas-profiler-reports-graph',
  templateUrl: './profiler-reports-graph.component.html',
  styleUrls: ['./profiler-reports-graph.component.less'],
  standalone: false
})
export class ProfilerReportsGraphComponent
  implements AfterViewInit, OnChanges, OnDestroy
{
  private _graphConfig: any;

  @Input() queryItem: ProfilerLofiQueryResult;
  @Input()
  get graphConfig(): any {
    return this._graphConfig;
  }

  set graphConfig(value: any) {
    this._graphConfig = value;
    this.orginalCustomColours = this.graphConfig.customColors;
  }

  @Input() pieGridView: [number, number] = [250, 620];
  @Input() numberCardView: [number, number] = [300, 620];
  @Input() height: number;
  @Input() resizeTick = 0;
  @ViewChild('graphContainer') graphContainer: ElementRef<HTMLDivElement>;
  @Output() graphClicked: EventEmitter<any> = new EventEmitter();

  private orginalCustomColours: any;
  private selectedNames: Set<string> = new Set();

  allowedCharts = [
    'bar-horizontal',
    'bar-vertical',
    'pie-chart',
    'advanced-pie-chart',
    'pie-grid',
    'tree-map',
    'number-card'
  ];
  readonly minGraphHeight = 250;
  chartView: [number, number] = [300, 250];
  private resizeObserver?: ResizeObserver;
  constructor() {}

  schemeType = ScaleType.Ordinal;

  ngAfterViewInit(): void {
    this.updateChartView();

    const graphElement = this.graphContainer?.nativeElement;
    if (graphElement && typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.updateChartView());
      this.resizeObserver.observe(graphElement);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resizeTick'] && !changes['resizeTick'].firstChange) {
      requestAnimationFrame(() => this.updateChartView());
    }
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  private updateChartView(): void {
    const graphElement = this.graphContainer?.nativeElement;
    if (!graphElement) {
      return;
    }

    const width = Math.max(Math.floor(graphElement.clientWidth), 1);
    const availableHeight = Math.max(Math.floor(graphElement.clientHeight), 0);
    const configuredMinHeight = this.height ?? this.minGraphHeight;
    const minHeight = Math.max(configuredMinHeight, this.minGraphHeight);
    const chartHeight = Math.max(availableHeight, minHeight);

    this.chartView = [width, chartHeight];
  }

  setColorScheme(name: string): string | Color {
    return colorSets.find((s: any) => s.name === name) as Color;
  }

  pieTooltipText(d: any) {
    return `
      <span class="tooltip-label">${d.data.name}</span>
      <span class="tooltip-val">${d.data.value}</span>
    `;
  }

  onGraphClick(evt: any) {
    this.graphClicked.emit({
      name: evt.name,
      mapLayerId: this.graphConfig?.mapLayerId
    });

    if (this.graphConfig?.mapLayerId) {
      this.graphConfig.customColors = this.spotlightColorArray(evt.name);
    }
  }

  private spotlightColorArray(selectedName: string) {
    // Toggle the selected name in the set
    if (this.selectedNames.has(selectedName)) {
      this.selectedNames.delete(selectedName);
    } else {
      this.selectedNames.add(selectedName);
    }

    // If no names are selected, return the original colours
    if (this.selectedNames.size === 0) {
      return this.orginalCustomColours;
    }

    // Generate the resulting array
    return this.orginalCustomColours.map((c: any) => {
      return {
        name: c.name,
        value: this.selectedNames.has(c.name) ? c.value : '#808080'
      };
    });
  }
}
